﻿export const projectSettings = {
	phoneNumber: (window.projectSettings && window.projectSettings.phoneNumber) || "",
	emailAddress: (window.projectSettings && window.projectSettings.emailAddress) || "",
	classActionName: (window.projectSettings && window.projectSettings.classActionName) || "",
	gSiteKey: (window.projectSettings && window.projectSettings.gSiteKey) || ""
};

export const referralTypes = [
	{ name: "Advertising" },
	{ name: "Client" },
	{ name: "Online" },
	{ name: "Family/Friend" },
	{ name: "Professional Referral" },
	{ name: "Staff Referral" },
	{ name: "Media" },
	{ name: "Word of Mouth" },
	{ name: "Other" }
];

export const salutationTypes = [
	{ name: "Dr" },
	{ name: "Mr" },
	{ name: "Miss" },
	{ name: "Ms" },
	{ name: "Mrs" },
	{ name: "Other" }
];

export const yesNoOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" }
];

export const yesNoWarningOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No *", value: "No" }
];

export const yesNoBooleanOptions = [
	{ label: "Yes", value: true },
	{ label: "No *", value: false }
];

export const yesNoUnsureOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" },
	{ label: "Unsure", value: "Unsure" }
];

export const voyages = [
	{
		label: "Fremantle, 5 December 2016 to 18 December 2016 (S622P)",
		value: "Fremantle, 5 December 2016 to 18 December 2016 (S622P)"
	},
	{
		label: "Margaret River, 18 December 2016 to 21 December 2016 (S623)",
		value: "Margaret River, 18 December 2016 to 21 December 2016 (S623)"
	},
	{
		label: "Indonesia, 21 December 2016 to 5 January 2017 (S701)",
		value: "Indonesia, 21 December 2016 to 5 January 2017 (S701)"
	},
	{
		label: "Margaret River, 5 January 2017 to 8 January 2017 (S702)",
		value: "Margaret River, 5 January 2017 to 8 January 2017 (S702)"
	},
	{
		label: "Northern Australia, 8 January 2017 to 22 January 2017 (S703)",
		value: "Northern Australia, 8 January 2017 to 22 January 2017 (S703)"
	},
	{
		label: "Papua New Guinea, 22 January 2017 to 2 February 2017 (S704)",
		value: "Papua New Guinea, 22 January 2017 to 2 February 2017 (S704)"
	},
	{
		label: "New Zealand, 2 February 2017 to 16 February 2017 (S705)",
		value: "New Zealand, 2 February 2017 to 16 February 2017 (S705)"
	},
	{
		label: "South Pacific, 16 February 2017 to 26 February 2017 (S706)",
		value: "South Pacific, 16 February 2017 to 26 February 2017 (S706)"
	}
];

export const bookingMethods = [
	{ label: "Travel agent", value: "Travel agent" },
	{ label: "Directly with Princess Cruises", value: "Directly with Princess Cruises" },
	{ label: "Unsure", value: "Unsure" },
	{ label: "Other", value: "Other" }
];

export const refundOptions = [
	{ label: "Yes, full refund", value: "Yes, full refund" },
	{ label: "Yes, partial refund", value: "Yes, partial refund" },
	{ label: "No", value: "No" }
];

export const disruptors = [
	{ label: "Contracted norovirus on the cruise", value: "Contracted norovirus on the cruise" },
	{
		label: "Travel companion contracted norovirus on the cruise",
		value: "Travel companion contracted norovirus on the cruise"
	},
	{
		label: "Saw other passengers contract and suffer from norovirus on the cruise",
		value: "Saw other passengers contract and suffer from norovirus on the cruise"
	},
	{ label: "Closure of amenities on the cruise", value: "Closure of amenities on the cruise" },
	{ label: "Other", value: "Other" }
];

export const disruptionRatingOptions = [
	{ label: "1 (mildly)", value: "1 (mildly)" },
	{ label: "2", value: "2" },
	{ label: "3", value: "3" },
	{ label: "4", value: "4" },
	{ label: "5 (severely)", value: "5 (severely)" }
];

export const acceptedFileUploadList =
	"application/pdf,.csv,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/docx,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
